/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="docs-and-forms.module.ts" />

module Meevo.Plugins.DocsAndForms {
    import CoSearchResultsFilter = Meevo.Model.CoSearchResultsFilter;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;
    import ISearchColumn = Meevo.Model.ISearchColumn;

    class DocsAndFormsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$translate',
            '$timeout',
            '$q',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
            'meevo.plugins.docsAndForms.SystemTagsFactory',
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
            '$sce',
            'meevo.plugins.interop.InteropService'
        ];

        private _docsAndFormsColumnsSettings: Array<ISearchColumn> = [
            { header: 'Description', fieldName: 'Description', sortDirection: null, width: 70 },
            { header: 'Status', fieldName: 'ObjectState', sortDirection: null, width: 15 },
            { header: '', fieldName: 'formCreationTypeEnum', sortDirection: null, width: 15 }
        ];
        public coColumnsCustom: Array<ISearchColumn> = this._docsAndFormsColumnsSettings;
        public displayNameColumnsCustom: ISearchColumn = {
            header: 'Display Name',
            fieldName: 'DisplayName',
            sortDirection: Model.SortDirection.Ascending,
            width: 40
        };

        public searchContextCriteria = {
            includeActive: true,
            coSearchType: null,
            coBusinessTypeId: null,
            coFilterByLocationId: null,
            coSearchResultFilter: CoSearchResultsFilter.All,
            location: null,
            businessType: null,
            maintenanceMode: true,
            formTypeEnum: FormTypeEnum.Form
        };

        get isSelectedFormBuilderSection() {
            return this.context && this.context.selectedSection instanceof FormBuilderSection;
        }

        get isFormBuilderOpened() {
            return this.isSelectedFormBuilderSection && (<FormBuilderSection>this.context.selectedSection).selectedBuilder !== BuilderEnum.None;
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $timeout: angular.ITimeoutService,
                    protected $q: ng.IQService,
                    protected docsAndFormsService: IDocsAndFormsService,
                    protected systemTagsFactory: SystemTagsFactory,
                    protected dafAPIService: DocsAndFormsApiService,
                    protected $sce: ng.ISCEService,
                    protected interopService: Meevo.Plugins.Interop.InteropService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.systemTagsFactory.prepareDocsAndFormsSystemTags();
        }

        /**
         * Creates the context for editing/adding an item.
         */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_DOCSANDFORMS_TAB_MAIN).then(() => {
                this.busyService.stop();
                this.context = new DocsAndFormsContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.$timeout,
                    this.busyService,
                    this.$q,
                    this.$translate,
                    this.docsAndFormsService,
                    this.dafAPIService,
                    this.$sce,
                    this.$scope,
                    this.systemTagsFactory,
                );
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.selectedItemId = null;
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant('HEADER_POINTS'), checked: false }
                    ];
            }).finally(() => {
                this.busyService.stop();
            });
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .controller('meevo.plugins.docsAndForms.DocsAndFormsController', DocsAndFormsController);
}
